import { RocketAPI } from '@portal/rocket-api-client';
import { createFileRoute } from '@tanstack/react-router';

import BillingEditPlanConfirmation from 'component/view/Settings/BillingEditPlanConfirmation';

import { requireOperation } from './-guards';

export const Route = createFileRoute(
  '/n/_auth/settings/_layout/billing/edit-plan/confirm/$planId/cycle/$billingCycle'
)({
  beforeLoad: requireOperation({
    options: () => RocketAPI.account.getUpdateAccountHostingPlanMutationOptions(),
    redirectTo: '/n/settings/account-and-security',
  }),
  component: BillingEditPlanConfirmation,
});
